<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      left-arrow
      :title="orderInfo.title"
      :z-index="10"
      @click-left="goableBack()"></van-nav-bar>
    <div class="list-contain" ref="container">
      <van-sticky offset-top="45px">
        <div class="order-top">
          <div class="top-bg">
            <div class="c2-1">
              {{ dateFormat(orderInfo.createTime, "YYYY年MM月DD日 HH:mm:ss") }}
            </div>
            <div class="c2-1-1" v-if="orderInfo.isCashCoupon">
              {{ getRebackStatus }}
            </div>
          </div>
          <div class="c2-2">
            <img :src="orderInfo.coverImg" alt="商品图片" fit="cover" />
            <div class="c2-3">
              <div class="c2-4">
                {{ orderInfo.name }}&nbsp; {{ orderInfo.title }}
              </div>
              <div class="c2-5">
                <div class="c2-6">{{ orderInfo.totalScore }}积分</div>
                <div class="c2-7">x{{ orderInfo.num }}</div>
              </div>
            </div>
          </div>
        </div>
      </van-sticky>

      <van-list>
        <van-cell
          v-for="(item, index) in dataSource"
          :key="item.id"
          :class="index == dataSource.length - 1 ? 'last-item' : ''"
          class="cell-2">
          <div class="c2-2">
            <div class="c2-4">
              {{ item.name }}&nbsp; {{ item.oldPrice }}{{ item.unit }}
            </div>
            <template v-if="item.availableExchange && item.status == 0">
              <van-button
                class="undo activite"
                @click="onUndo(item.id, index)"
                >{{ getUndoStateName(item.status) }}</van-button
              >
            </template>
            <template v-else>
              <van-button class="undo">{{
                getUndoStateName(item.status)
              }}</van-button>
            </template>
          </div>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>
  
  <script>
import { Cell, Dialog, List, PullRefresh, Sticky } from "vant"
import * as MallApi from "@/api/mall"
import { mapActions } from "vuex"
export default {
  name: "allorder",
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Cell.name]: Cell,
    [Sticky.name]: Sticky,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      container: null,
      dataSource: [],
      orderInfo: {}
    }
  },
  mounted() {
    // this.container = this.$refs.container
    this.orderInfo = JSON.parse(this.$route.params.item)
    this.onLoad()
  },
  computed: {
    getRebackStatus() {
      let array = this.dataSource.filter((item) => !item.availableExchange)
      if (array.length === 0) {
        return this.orderInfo.rebackStatus
      } else {
        return array.length === this.dataSource.length ? "已撤销" : "已部分撤销"
      }
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    onLoad() {
      MallApi.getscoreOrderInfo(this.orderInfo.id)
        .then((data) => {
          if (data) {
            this.dataSource = data
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    onUndo(recordId, index) {
      this._showLoading()
      MallApi.getExchangeSingleOptions(recordId)
        .then((data) => {
          this._dismissLoading()
          if (data) {
            Dialog.alert({
              title: "温馨提示",
              message: data,
              confirmButtonText: "确认",
              showCancelButton: true,
              theme: "round-button"
            })
              .then(() => {
                this.onCancelOrder(recordId, index)
              })
              .catch(() => {})
          }
        })
        .catch((e) => {
          this._dismissLoading()
          this.$toast(e.msg || e.message)
        })
    },
    onCancelOrder(recordId, index) {
      this._showLoading()
      MallApi.undoExchangeCancelSingle(recordId)
        .then((data) => {
          this._dismissLoading()
          if (data) {
            let item = this.dataSource[index]
            item.availableExchange = false
            item.status = 3
            this.getUserInfo()
            // this.dataSource.splice(index, 1)
          }
        })
        .catch((e) => {
          this._dismissLoading()
          this.$toast(e.msg || e.message)
        })
    },
    getUndoStateName(status) {
      // 0-未使用 1-已使用 2-已过期 3-已撤销
      let name = ""
      switch (status) {
        case 0:
          name = "撤销"
          break
        case 1:
          name = "已使用"
          break
        case 2:
          name = "已过期"
          break
        case 3:
          name = "已撤销"
          break

        default:
          break
      }
      return name
    }
  }
}
</script>
  
  <style lang="less" scoped>
.page-container {
  background-color: white;
}
.list-contain {
  margin: 10px 30px;
  margin-bottom: 0px;
  padding-bottom: 30px;
  ::v-deep .van-sticky--fixed {
    left: 30px;
    right: 30px;
    background-color: white;
  }
  .order-top {
    padding: 0.2667rem 0.42667rem;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: rgb(236, 237, 239);
    .top-bg {
      display: flex;
      justify-content: space-between;
      .c2-1 {
      }
      .c2-1-1 {
        color: rgb(226, 152, 56);
      }
    }
    .c2-2 {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    img {
      flex: 0.6;
      width: 110px;
      height: 70px;
      border-radius: 10px;
      margin-right: 15px;
    }
    .c2-3 {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
    }
    .c2-4 {
      font-weight: 500;
      margin-top: 5px;
    }
    .c2-5 {
      display: flex;
      justify-content: space-between;
      margin-top: 5px;
      .c2-6 {
        color: rgb(188, 26, 32);
      }
    }
  }
  .cell-2 {
    background-color: rgb(236, 237, 239);
    border-bottom: 1px solid rgb(151, 151, 151);
    .c2-2 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 10px;
      .c2-4 {
        font-weight: 500;
      }
      .undo {
        background-color: transparent;
        border: 0px solid rgb(151, 151, 151);
        color: rgb(55, 55, 55);
        min-width: 70px;
        border-radius: 18px;
        margin: 5px 0;
        ::v-deep(.van-button::before) {
          background-color: transparent;
        }
      }
      .activite {
        border: 1px solid rgb(226, 152, 56);
        color: rgb(226, 152, 56);
      }
    }
  }
  .last-item {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-bottom: 0 solid rgb(151, 151, 151);
  }
}
</style>